import { render, staticRenderFns } from "./InfoStep.vue?vue&type=template&id=9b20ba54&scoped=true&"
import script from "./InfoStep.vue?vue&type=script&lang=js&"
export * from "./InfoStep.vue?vue&type=script&lang=js&"
import style0 from "./InfoStep.vue?vue&type=style&index=0&id=9b20ba54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b20ba54",
  null
  
)

export default component.exports